// Projects.js
import { useState } from "react";
import "./Projects.css";
import simplerPianoImg from "../assets/img/Simpler-Piano.gif";
import projImg2 from "../assets/img/dormbnb.jpg";
import projImg3 from "../assets/img/ytubehome.gif";
import projImg4 from "../assets/img/typingtest.gif";
import projImg5 from "../assets/img/cube_updated.png";
import instaImg from "../assets/img/instagram.gif";
import projImg6 from "../assets/img/pagination.jpg";
import chromeExtImg from "../assets/img/tutorial03.gif";
import ytCommentSortImg from "../assets/img/ytcommentsorter.png";
import visualizerImg from "../assets/img/visualizer.gif";
import blackjackImg from "../assets/img/ace.png";

const allProjects = [
  {
    title: "Blackjack Cheating Sim",
    description: "Practice card counting with live decks, strategy tips, autoplay, detailed stats, and an optional cheat mode replicating real casino cheating.",
    technologies: "React, Zustand, Vite, Tailwind CSS",
    imgUrl: blackjackImg,
    address: "https://ace.billy-chiu.com",
    github: "https://github.com/13illydakid/twenty-one",
  },
  {
    title: "Algorithmic Visualizer",
    description: "Real‑time animated sorting lab with speed, stats, and theme control.",
    technologies: "React, Redux, Webpack, Babel, CSS (custom theming)",
    imgUrl: visualizerImg,
    address: "https://viz.billy-chiu.com",
    github: "https://github.com/13illydakid/algorithmic-visualizer",
  },
  {
    title: "Rubik’s Cube Simulator",
    description: "Improve spatial awareness using 3D cube simulation.",
    technologies: "THREE.js, React, Parcel, jQuery, Dat.gui",
    imgUrl: projImg5,
    address: "https://cube.billy-chiu.com",
    github: "https://github.com/13illydakid/rubiks-cube",
  },
  {
    title: "Interactive Piano Practice",
    description: "Simulates piano play with live note visuals.",
    technologies: "Next.js, TypeScript, Tailwind, Skia Canvas, tonejs",
    imgUrl: simplerPianoImg,
    address: "https://piano.billy-chiu.com",
    github: "https://github.com/13illydakid/simpler-piano",
  },
  {
    title: "Instagram",
    description: "Google sign-in, image upload, like, comment, stories, suggestions.",
    technologies: "Next.js, Next-Auth, Recoil, Firebase v9",
    imgUrl: instaImg,
    address: "https://gallery.billy-chiu.com",
    github: "https://github.com/13illydakid/instagram-clone-2.0",
  },
  {
    title: "Property Management System",
    description: "CRUD-based system for managing rental listings.",
    technologies: "React, Node, Express, Sequelize, Postgres",
    imgUrl: projImg2,
    address: "https://pms.billy-chiu.com",
    github: "https://github.com/13illydakid/api-design",
  },
  {
    title: "YouTube Comment Sorter Chrome Extension",
    description: "A Chrome extension that opens a modal on YouTube video pages to sort, search, and paginate comments. No backend required.",
    technologies: "JavaScript, HTML",
    imgUrl: ytCommentSortImg,
    github: "https://github.com/13illydakid/yt-comment-sorter",
  },
  {
    title: "Typing Test",
    description: "Python-based app for evaluating real-time typing speed.",
    technologies: "Python, Tkinter",
    imgUrl: projImg4,
    address: "https://type.billy-chiu.com",
    github: "https://github.com/13illydakid/Type-Test",
  },
  {
    title: "YouTube Homepage Clone",
    description: "Responsive YouTube homepage built with Tailwind.",
    technologies: "React, TypeScript, Tailwind",
    imgUrl: projImg3,
    address: "https://ytube.billy-chiu.com",
    github: "https://github.com/13illydakid/youtube-homepage",
  },
  {
    title: "Pagination Chrome Extension",
    description: "Use Ctrl+N/P to navigate ecommerce pages faster.",
    technologies: "JavaScript, Chrome API",
    imgUrl: projImg6,
    github: "https://github.com/13illydakid/Pagination-Chrome-Extension",
  },
  {
    title: "All Chrome Extensions",
    description: "Collection of multiple custom extensions.",
    technologies: "HTML, CSS, JS",
    imgUrl: chromeExtImg,
    github: "https://github.com/13illydakid/ChromeExtensions-Joined",
  }
];

export const Projects = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <section className="project-container fade-pop" id="projects">
      <div className="project-showcase glass-surface gradient-ring active-project-wrapper">
          <div className="showcase-media">
            <img src={allProjects[activeIndex].imgUrl} alt={allProjects[activeIndex].title} className="main-image" />
          </div>
          <div className="showcase-info">
            <h2 className="project-title">{allProjects[activeIndex].title}</h2>
            <p className="project-desc">{allProjects[activeIndex].description}</p>
            <span className="project-tech">{allProjects[activeIndex].technologies}</span>
            <div className="project-links">
              {allProjects[activeIndex].address && (
                <a className="pill-link" href={allProjects[activeIndex].address} target="_blank" rel="noreferrer">View Site</a>
              )}
              {allProjects[activeIndex].github && (
                <a className="pill-link" href={allProjects[activeIndex].github} target="_blank" rel="noreferrer">GitHub</a>
              )}
            </div>
          </div>
          <div></div>
      </div>
      <div></div>
      <div className="project-thumbnails-wrapper gradient-ring">
        <div className="project-thumbnails glass-surface">
          {allProjects.map((proj, idx) => (
            <div
              key={idx}
              className={`thumbnail ${idx === activeIndex ? "active" : ""}`}
              onClick={() => setActiveIndex(idx)}
            >
              <img src={proj.imgUrl} alt={proj.title} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
